import React from 'react';
import { createLinks } from './createLinks';
import { loggedUserPages, settingPages } from '../../../../routes/pages';
import { useStyle } from './menuSidebar.style';

const MenuSidebar = React.memo(() => {
  const classes = useStyle();
  return (
    <>
      <div className={classes.linksContainer}>
        {createLinks(loggedUserPages)}
      </div>
      <div className={classes.linksContainer}>{createLinks(settingPages)}</div>
    </>
  );
});

MenuSidebar.displayName = 'MenuSidebar';

export default MenuSidebar;
